var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner icon-md text-white fill-current"},[_c('use',{attrs:{"xlink:href":"/assets/icons.svg#spinner"}})])}
var staticRenderFns = []

export { render, staticRenderFns }